import axios from 'axios';

class ChannelService {
    async getChannelList(page, limit = 25, sortBy = 'subscriberCount', sortOrder = 'DESC') {
        const params = {
            page,
            limit,
            sortBy,
            sortOrder
        };

        return await axios.get(`${process.env.REACT_APP_API_URL}/api/channels`, {
            params: params,
            headers: {
                "X-API-KEY": process.env.REACT_APP_API_KEY,
                "Content-Type": "application/json"
            },
        }).then(response => {
            return {
                items: response.data.items,
                pagination: {
                    page: response.data.page,
                    limit: response.data.limit,
                    totalPages: response.data.total_pages,
                    totalItems: response.data.total_items
                },
                criteria: response.data.criteria || {}
            };
        });
    }
}

const channelService = new ChannelService();
export default channelService;

